import { Button, Spinner } from "@sellar-io/components";
import { Link, Navigate, useSearchParams } from "react-router";
import { ORDER_SUCCESS_BUYER, ORDERS } from "~/constants/routes";
import { useRyftManagementPaymentSessionOrder } from "~/hooks/api/v2/ryftManagement/useRyftManagementPaymentSessionOrder";

export const RyftPaymentSessionRedirect = () => {
  const [searchParams] = useSearchParams();
  const paymentSessionId = searchParams.get("ps");
  const { data, isError, isFetching, refetch } =
    useRyftManagementPaymentSessionOrder(paymentSessionId);

  if (data) {
    return (
      <Navigate
        to={ORDER_SUCCESS_BUYER.href({
          supplierIdOrUrlId: data.Order.Supplier.urlId,
          orderId: data.Order.id,
        })}
        replace
      />
    );
  }

  if (!paymentSessionId || isError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-semibold">We couldn't open your order</h1>
        <p>Please try again or find your order on the orders page.</p>
        {paymentSessionId && (
          <Button onClick={() => refetch()} loading={isFetching}>
            Try again
          </Button>
        )}
        <Link to={ORDERS} className="underline">
          View your orders
        </Link>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <Spinner />
      <p>Opening your order...</p>
    </div>
  );
};
